// src/actions/hardware_actions.js
import axios from "axios";
import {
    FETCH_HARDWARE_SOLD_LOADING,
    FETCH_HARDWARE_SOLD_SUCCESS,
    FETCH_HARDWARE_SOLD_FAIL,
    
    FETCH_HARDWARE_CRAFTED_LOADING,
    FETCH_HARDWARE_CRAFTED_SUCCESS,
    FETCH_HARDWARE_CRAFTED_FAIL,
    
    FETCH_HARDWARE_ACTIVE_LOADING,
    FETCH_HARDWARE_ACTIVE_SUCCESS,
    FETCH_HARDWARE_ACTIVE_FAIL,
    
    FETCH_HARDWARE_ACTIVATED_LOADING,
    FETCH_HARDWARE_ACTIVATED_SUCCESS,
    FETCH_HARDWARE_ACTIVATED_FAIL,

    FETCH_HARDWARE_DRINKS_LOADING,
    FETCH_HARDWARE_DRINKS_SUCCESS,
    FETCH_HARDWARE_DRINKS_FAIL,

    FETCH_HARDWARE_DETAILS_LOADING,
    FETCH_HARDWARE_DETAILS_SUCCESS,
    FETCH_HARDWARE_DETAILS_FAIL,

    FETCH_HARDWARE_ING_HISTORY_LOADING,
    FETCH_HARDWARE_ING_HISTORY_SUCCESS,
    FETCH_HARDWARE_ING_HISTORY_FAIL,

    FETCH_HARDWARE_USERS_LOADING,
    FETCH_HARDWARE_USERS_SUCCESS,
    FETCH_HARDWARE_USERS_FAIL,

    FETCH_HARDWARE_RECENT_DRINKS_LOADING,
    FETCH_HARDWARE_RECENT_DRINKS_SUCCESS,
    FETCH_HARDWARE_RECENT_DRINKS_FAIL,

    FETCH_HARDWARE_MOST_REPEATED_DRINKS_LOADING,
    FETCH_HARDWARE_MOST_REPEATED_DRINKS_SUCCESS,
    FETCH_HARDWARE_MOST_REPEATED_DRINKS_FAIL,

    FETCH_PAGINATED_DEVICES_LOADING,
    FETCH_PAGINATED_DEVICES_SUCCESS,
    FETCH_PAGINATED_DEVICES_FAIL,
    SET_PAGINATED_DEVICES_PAGE,

    FETCH_HARDWARE_LAST_CONNECTED_HISTORY_LOADING,
    FETCH_HARDWARE_LAST_CONNECTED_HISTORY_SUCCESS,
    FETCH_HARDWARE_LAST_CONNECTED_HISTORY_FAIL,

    FETCH_HARDWARE_CLEANING_HISTORY_LOADING,
    FETCH_HARDWARE_CLEANING_HISTORY_SUCCESS,
    FETCH_HARDWARE_CLEANING_HISTORY_FAIL,
} from "./types";

//Fetch Device Cleaning History per Station - Expanded Table Data
export const fetchHardwareCleaningHistory = (deviceId) => async (dispatch) => {
  dispatch({ type: FETCH_HARDWARE_CLEANING_HISTORY_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/cleaning-history`;
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const { data } = response;
    if (data.success) {
      dispatch({
        type: FETCH_HARDWARE_CLEANING_HISTORY_SUCCESS,
        payload: data.data
      });
    } else {
      dispatch({
        type: FETCH_HARDWARE_CLEANING_HISTORY_FAIL,
        payload: data.message || 'Unknown error'
      });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({
      type: FETCH_HARDWARE_CLEANING_HISTORY_FAIL,
      payload: errorMessage
    });
  }
};


// Action to fetch last connected history for a device
export const fetchHardwareLastConnectedHistory = (deviceId) => async (dispatch) => {
  dispatch({ type: FETCH_HARDWARE_LAST_CONNECTED_HISTORY_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/last-connected-history`;
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const { data } = response;
    if (data.success) {
      dispatch({
        type: FETCH_HARDWARE_LAST_CONNECTED_HISTORY_SUCCESS,
        payload: data.data, // Adjust according to the actual response format
      });
    } else {
      dispatch({
        type: FETCH_HARDWARE_LAST_CONNECTED_HISTORY_FAIL,
        payload: data.message || "Unknown error",
      });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({
      type: FETCH_HARDWARE_LAST_CONNECTED_HISTORY_FAIL,
      payload: errorMessage,
    });
  }
};


export const setPaginatedDevicesPage = (page) => ({
  type: SET_PAGINATED_DEVICES_PAGE,
  payload: page,
});

//Fetch Paginated Devices per activity

export const fetchPaginatedDevices = (page = 1, perPage = 10) => async (dispatch) => {
  dispatch({ type: FETCH_PAGINATED_DEVICES_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/paginated-devices`;
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, perPage },
    });
    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_PAGINATED_DEVICES_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_PAGINATED_DEVICES_FAIL, payload: data.message });
    }
  } catch (error) {
    dispatch({
      type: FETCH_PAGINATED_DEVICES_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};



// Fetch most repeated drinks for a hardware device
export const fetchHardwareMostRepeatedDrinks = (deviceId, limit = 10) => async (dispatch) => {
  dispatch({ type: FETCH_HARDWARE_MOST_REPEATED_DRINKS_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/most-repeated-drinks?limit=${limit}`;
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_MOST_REPEATED_DRINKS_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_HARDWARE_MOST_REPEATED_DRINKS_FAIL, payload: data.message || "Unknown error" });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_MOST_REPEATED_DRINKS_FAIL, payload: errorMessage });
  }
};

// Fetch 2 most recent drinks for a hardware device
export const fetchHardwareRecentDrinks = (deviceId) => async (dispatch) => {
    dispatch({ type: FETCH_HARDWARE_RECENT_DRINKS_LOADING });
    try {
        const token = localStorage.getItem("jwtToken");
        const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/drinks-made-by-device?page=1&perPage=2`;
        const response = await axios.get(apiUrl, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const { data } = response;
        if (data.success) {
            // Your backend may return data as { success, drinks, ... } or { success, data: {...} }
            // Adjust as per your response structure!
            dispatch({ type: FETCH_HARDWARE_RECENT_DRINKS_SUCCESS, payload: data.drinks || data.data || [] });
        } else {
            dispatch({ type: FETCH_HARDWARE_RECENT_DRINKS_FAIL, payload: data.message || "Unknown error" });
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message;
        dispatch({ type: FETCH_HARDWARE_RECENT_DRINKS_FAIL, payload: errorMessage });
    }
};


// Fetch users for a hardware device
export const fetchHardwareUsers = (deviceId) => async (dispatch) => {
    dispatch({ type: FETCH_HARDWARE_USERS_LOADING });
    try {
        const token = localStorage.getItem("jwtToken");
        const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/users`;
        const response = await axios.get(apiUrl, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const { data } = response;
        if (data.success) {
            dispatch({ type: FETCH_HARDWARE_USERS_SUCCESS, payload: data.data });
        } else {
            dispatch({ type: FETCH_HARDWARE_USERS_FAIL, payload: data.message || "Unknown error" });
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message;
        dispatch({ type: FETCH_HARDWARE_USERS_FAIL, payload: errorMessage });
    }
};

// Fetch Ingredients History for a device
export const fetchHWIngredientsHistory = (deviceId) => async (dispatch) => {
  dispatch({ type: FETCH_HARDWARE_ING_HISTORY_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/ingredients-history`;
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_ING_HISTORY_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_HARDWARE_ING_HISTORY_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_ING_HISTORY_FAIL, payload: errorMessage });
  }
};

// Fetch Station Details by Device ID
export const fetchHWDetailsByDevice = (deviceId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/station-details`;
  dispatch({ type: FETCH_HARDWARE_DETAILS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_DETAILS_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_HARDWARE_DETAILS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_DETAILS_FAIL, payload: errorMessage });
  }
};

//HW Drinks Made
export const fetchHardwareDrinks = ({
  deviceId,
  page = 1,
  perPage = 20,
}) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/${deviceId}/drinks-made-by-device`;

  dispatch({ type: FETCH_HARDWARE_DRINKS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, perPage },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_DRINKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_HARDWARE_DRINKS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_DRINKS_FAIL, payload: errorMessage });
  }
};

// Action H/W Active Info (merged, MySQL default)
export const fetchHWActiveInfo = (
  startTime,
  endTime,
  filter,
  source = 'mysql' // mysql | pg | both
) => async (dispatch) => {
  dispatch({ type: FETCH_HARDWARE_ACTIVE_LOADING });

  try {
    const token  = localStorage.getItem("jwtToken");
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/hardware/hardware-active-info-merged`;

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { filter, startTime, endTime, source },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_ACTIVE_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_HARDWARE_ACTIVE_FAIL, payload: data.message });
    }
  } catch (error) {
    dispatch({
      type: FETCH_HARDWARE_ACTIVE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};


//Action H/W Crafted Info
export const fetchHWCraftedInfo = (startTime, endTime, filter) => async (dispatch) => {
  dispatch({ type: FETCH_HARDWARE_CRAFTED_LOADING });

  try {
    const token  = localStorage.getItem("jwtToken");
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/hardware-crafted-v3-merged`;

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { filter, startTime, endTime, source: 'mysql' },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_CRAFTED_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_HARDWARE_CRAFTED_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_CRAFTED_FAIL, payload: errorMessage });
  }
};

//Action User Tile Info for Total Registered Users Expansion Chart
export const fetchHWSoldInfo = (startTime, endTime, filter) => async (dispatch) => {
  // console.log("fetchHWSoldInfo action invoked with:", { filter, startTime, endTime });
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/hardware-sold-v4-merged`;
  // http://localhost:9890/secureapi/analytics/dashboard/hardware-sold-v4-merged?filter=0&startTime=2023-01-01T00:00:00Z&endTime=2025-12-31T23:59:59Z

  dispatch({ type: FETCH_HARDWARE_SOLD_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      // MySQL is default on the merged endpoint; no need to pass source/mode
      params: { filter, startTime, endTime },
    });

    // console.log("HW SOLD Info API Response:", response);
    const { data } = response;
    if (data.success) {
      // console.log("///////////// H/W Sold Info:", data);
      dispatch({ type: FETCH_HARDWARE_SOLD_SUCCESS, payload: data.data });
    } else {
      // console.log("H/W Sold Info:", data);
      dispatch({ type: FETCH_HARDWARE_SOLD_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_SOLD_FAIL, payload: errorMessage });
  }
};

  //Action User Tile Info for Total Registered Users Expansion Chart
export const fetchHWActivatedInfo = (startTime, endTime, filter) => async (dispatch) => {
  // console.log("fetchHWActivatedInfo action invoked with:", { filter, startTime, endTime });
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/hardware-activated-v4-merged`;
  // MySQL-only for now (default behavior of merged endpoint)

  dispatch({ type: FETCH_HARDWARE_ACTIVATED_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { filter, startTime, endTime },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_ACTIVATED_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_HARDWARE_ACTIVATED_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_ACTIVATED_FAIL, payload: errorMessage });
  }
};

  
  
